import { render, staticRenderFns } from "./CmgRewardsAchievementsBody.vue?vue&type=template&id=06eadee8&scoped=true&lang=pug"
import script from "./cmg-rewards-achievements-body.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-achievements-body.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsAchievementsBody.vue?vue&type=style&index=0&id=06eadee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eadee8",
  null
  
)

export default component.exports